'use client'

import { useSyncExternalStore } from 'react'

export interface ApplePlatformNavigator {
  userAgent: string
  platform?: string
  maxTouchPoints?: number
}

export function isAppleWebPlatform(
  navigatorLike?: ApplePlatformNavigator
): boolean {
  const browserNavigator = navigatorLike
    ?? (typeof window !== 'undefined' ? window.navigator : undefined)

  if (!browserNavigator) return false

  const userAgent = browserNavigator.userAgent ?? ''
  const platform = browserNavigator.platform ?? ''

  if (/iPhone|iPad|iPod/.test(userAgent)) return true
  if (/Macintosh|Mac OS X/.test(userAgent)) return true

  // iPadOS can request desktop websites and report itself as MacIntel.
  return platform === 'MacIntel' && (browserNavigator.maxTouchPoints ?? 0) > 1
}

export function useAppleWebAuthAvailability(isNativeApp: boolean): boolean {
  const isApplePlatform = useSyncExternalStore(
    () => () => undefined,
    () => isAppleWebPlatform(),
    () => false
  )

  return !isNativeApp && isApplePlatform
}
